import { render, staticRenderFns } from "./NoticiasMercadoVideosList.vue?vue&type=template&id=1596d9dc&"
import script from "./NoticiasMercadoVideosList.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoVideosList.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoVideosList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports